import loadable from '@loadable/component';

export const ItproportalSiteWrapper = loadable(
  () => import(/* webpackChunkName: "itproportal-site" */ './ItproportalSiteWrapper'),
);
